export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5925.0844b6e0.jpg";